import React from "react";
import {
  createBrowserRouter,
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router";

import * as Sentry from "@sentry/react";

import { getBuildId } from "@features/appVersion/deployVersionGuard";

Sentry.init({
  dsn: "https://7de2e54c16737037c3a901cc635c0a03@o555075.ingest.us.sentry.io/4508938338172928",
  environment: import.meta.env.VITE_DEV_ENV,
  integrations: [
    Sentry.globalHandlersIntegration(),
    Sentry.reactRouterV7BrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    Sentry.extraErrorDataIntegration({
      depth: 5,
    }),
    Sentry.replayIntegration({
      maskAllText: false,
    }),
  ],
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.

  normalizeDepth: 5,
  tracesSampleRate: 1.0,
  tracePropagationTargets: [/^\/api/],
  sendDefaultPii: true,
  denyUrls: [/extensions\//i, /^chrome:\/\//i, /^moz-extension:\/\//i],
  beforeSend(event, hint) {
    const original = hint?.originalException as any;
    const code = original?.code ?? original?.message ?? "";
    const status = original?.response?.status;

    // drop aborted/canceled and 401 auth flow noise
    const isAbort = /AbortError|ECONNABORTED|ERR_CANCELED|ERR_NETWORK/i.test(
      code
    );
    if (isAbort || status === 401) return null;

    return event;
  },
  enabled: import.meta.env.VITE_DEV_ENV !== "dev",
  initialScope: {
    tags: {
      build_id: getBuildId() ?? "unknown",
    },
  },
});
export const sentryCreateBrowserRouterV7 =
  Sentry.wrapCreateBrowserRouterV7(createBrowserRouter);
